export default __webpack_public_path__ + "static/media/mh.00401bdb.svg";